import Swiper from 'swiper/bundle';

jQuery(document).ready(function () {
   swiperSlider();
   initMobileMenu();
   mapLoader();
});


function swiperSlider() {
   const mySwiper = new Swiper('.hero-slider', {
      loop: true,

      // Classic slide effect
      effect: 'slide',
      speed: 1200,

      pagination: {
         el: '.hero-slider .swiper-pagination',
         clickable: true,
      },

      navigation: {
         nextEl: '.hero-slider .swiper-button-next',
         prevEl: '.hero-slider .swiper-button-prev',
      },

      autoplay: {
         delay: 4000,
         disableOnInteraction: false,
         pauseOnMouseEnter: false,
      },

      // Makes dragging & button clicks smoother
      grabCursor: true,
      resistanceRatio: 0.85,
   });

   mySwiper.autoplay.start();
}


function initMobileMenu() {
   // Select elements
   const burger = $('.burger-menu');
   const menu = $('.mobile-navigation-menu');
   const overlay = $('.mobile-overlay');
   const mobileMenu = $('.mobile-menu');

   // Open mobile menu
   function openMenu() {
      menu.addClass('open');
      overlay.show();
      burger.addClass('active');
   }

   // Close mobile menu
   function closeMenu() {
      menu.removeClass('open');
      overlay.hide();
      burger.removeClass('active');

      // Reset all sub-menus
      mobileMenu.find('.menu-item-has-children').removeClass('open');
   }

   // Burger toggle
   burger.on('click', function () {
      if (menu.hasClass('open')) {
         closeMenu();
      } else {
         openMenu();
      }
   });

   // Close menu when clicking overlay or normal menu items
   $('.mobile-overlay, .close-menu, .mobile-menu .menu-item:not(.menu-item-has-children)')
      .on('click', closeMenu);

   // Sub-menu toggle
   mobileMenu.find('.menu-item-has-children > a').on('click', function (e) {
      e.preventDefault(); // Prevent default link behavior

      const item = $(this).parent();

      // Toggle current sub-menu
      item.toggleClass('open');

      // Close sibling sub-menus (accordion)
      item.siblings('.menu-item-has-children').removeClass('open');
   });

   //desktop
   let closeTimer;

   $('.nav-menu .menu-item-has-children')
      .on('mouseenter', function () {
         clearTimeout(closeTimer);
         $(this).children('.sub-menu').addClass('is-active');
      })
      .on('mouseleave', function () {
         const submenu = $(this).children('.sub-menu');
         closeTimer = setTimeout(function () {
            submenu.removeClass('is-active');
         }, 200); // ← delay in ms (300–600 is ideal)
      });
}


function mapLoader() {
   jQuery('#accept-dsgvo').on('click', function () {
      jQuery('.hide-on-accept').css('display', 'none');
      jQuery('.map-widget').css('background-image', 'unset');
      let loc = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2458.5559520545207!2d8.228976999999999!3d51.9602885!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47b989c52c948ba1%3A0xccfc305b08c62055!2sPraxis%20Dr.%20Zak!5e0!3m2!1sde!2sde!4v1777030421609!5m2!1sde!2sde";
      jQuery('#map-location').css({"display": "block", "width": "100%", "height": "100%"});
      document.getElementById('map-location').setAttribute('src', loc);
   });
}
